import type { Arm, NavImpactSurfaces } from '../AutotestNavImpactStats';

import { spec as qaSinkDelta } from './qa_sink_delta';
import { spec as qaSinkIcons } from './qa_sink_icons';
import { spec as v1DeltaChips } from './v1_delta_chips';
import { spec as v2PlainCounts } from './v2_plain_counts';
import { spec as v3PlainCountsAlt } from './v3_plain_counts_alt';
import { spec as v4TrendIcons } from './v4_trend_icons';

export type ArmSpec = () => Partial<NavImpactSurfaces>;

export const ARMS: Partial<Record<Arm, ArmSpec>> = {
  v1_delta_chips: v1DeltaChips,
  v2_plain_counts: v2PlainCounts,
  v3_plain_counts_alt: v3PlainCountsAlt,
  v4_trend_icons: v4TrendIcons,
  qa_sink_delta: qaSinkDelta,
  qa_sink_icons: qaSinkIcons,
};
